
(function () {

    'use strict';

    const SELECTED_CATALOG_KEY = "visit_procedure_catalog";

    class ProceduresSelectionCtrl {
        constructor($mdDialog, $translate, visitService, catalogService, $q, $element, $timeout, paymentService, $scope, configService, warehouseService) {
            this.dialog = $mdDialog;
            this.translate = $translate;
            this.visitService = visitService;
            this.catalogService = catalogService;
            this.$q = $q;
            this.$element = $element;
            this.$timeout = $timeout;
            this.paymentService = paymentService;
            this.warehouseService = warehouseService;
            this.$scope = $scope;

            this.advanceForm = configService.hasAdvanceVisitFinancial();

        }

        static get $inject() {
            return [
                "$mdDialog", "$translate", "visitService", "catalogService", "$q", "$element", "$timeout", "paymentService", "$scope",
                "configService", "warehouseService"
            ];
        }

        $onInit() {
            this.instance = this.instance || {};
            this.instance.procedures = this.instance.procedures || [];
            this.instance.financial_status = this.instance.financial_status || {
                global_discount: 0,
                global_percentage_discount: 0,
                gross_total: 0,
                total: 0,
                is_validated: false
            };
            this.selectedCatalog = this.selectedCatalog || null;
            this.visitProcedures = this.visitProcedures || [];

            const savedId = parseInt(localStorage.getItem(SELECTED_CATALOG_KEY)) || null;
            const promises = [
                this.visitService.getProcedures(),
                this.warehouseService.getDefault()
            ];
            if (!!savedId) promises.push(this.catalogService.getCatalog(savedId));

            this.promise = this.$q.all(promises)
                .then(data => {
                    this.initProcedures = this.procedures = data[0];
                    this.visitProcedures = this.instance.procedures;
                    this.selectedCatalog = data[2] || null;

                    if(this.advanceForm) {
                        const defaultWarehouse = data[1]
                        if(this.instance.delivery_document) {
                            this.instance.delivery_document.doc_date = this.instance.delivery_document.doc_date || this.instance.visit_date;
                            this.instance.delivery_document.warehouse = this.instance.delivery_document.warehouse || defaultWarehouse;
                        } else {
                            this.instance.delivery_document = {
                                price_mode: 'TTC',
                                patient: this.instance.patient_id,
                                doc_date: this.instance.visit_date,
                                warehouse: defaultWarehouse,
                                lines: []
                            }
                        }
                    }
                    this.$timeout(() => this.calculateHeight());
                })

                this.applyDiscount = this.paymentService.applyDiscount;

            this.$scope.$watch("vm.total()", value => {
                if (_.isNil(this.instance) || _.get(this.instance, 'financial_status.total') === value) return false;

                this.instance.financial_status.gross_total = value;

                this.$timeout(() => this.calculateHeight(), 300);
            });

            // Watch for instance changes (handles async loading from parent)
            this.$scope.$watch(() => this.instance, (newInstance) => {
                if (newInstance && newInstance.procedures && newInstance.procedures !== this.visitProcedures) {
                    this.visitProcedures = newInstance.procedures;
                    this.$timeout(() => this.calculateHeight());
                }
            });

        }

        addProcedure(procedure) {
            this.visitProcedures = this.visitProcedures || [];
            let existence = _.find(this.visitProcedures, {name: procedure.name, procedure: {id: procedure.id}});

            if (_.isUndefined(existence)) this.visitProcedures.push(this.procedureToVisit(procedure));
            else existence.qte += 1;

            this.$timeout(() => this.calculateHeight());
        }

        total(net = false) {
            let start = 0;
            if (this.instance) {
                const deliveryDocumentTaxedTotal = _.get(this.instance, "delivery_document.taxed_total", 0);
                const globalDiscount = this.instance.financial_status.global_discount;
                start = net ? deliveryDocumentTaxedTotal - globalDiscount : deliveryDocumentTaxedTotal;
            }

            const t = _.reduce(this.visitProcedures, (result, item) => {
                return result + item['qte'] * (item['price'] - item['discount']);
            }, start);

            return _.isNaN(t) ? 0 : t;
        }

        remove(index) {
            this.visitProcedures.splice(index, 1);
            this.$timeout(() => this.calculateHeight());
        }

        procedureToVisit(procedure) {
            let visitProcedure = _.pick(procedure, ['name', 'price']);
            return _.assign(visitProcedure, {qte: 1, discount: 0, total_discount: 0, procedure: procedure});
        }

        procedureDiscountChange(item, field) {
            switch (field) {
                case "line":
                    item.total_discount = item.discount * item.qte;
                    break;
                default:
                    item.discount = item.total_discount / item.qte;
                    break;
            }

        }

        prePrint() {
            return this.visitService.updateVisit(this.instance, ['procedures', 'financial_status']);
        }

        // empty
        emptyVisitDetail(ev) {
            let confirm = this.dialog.confirm()
                .multiple(true)
                .targetEvent(ev)
                .ariaLabel('empty visitInstance financial warning')
                .ok(this.translate.instant('confirm'))
                .cancel(this.translate.instant('cancel'))
                .title(this.translate.instant('empty_financial_confirm_msg'));

            this.dialog.show(confirm).then(() => {
                this.visitProcedures = [];
                if (this.advanceForm) this.instance.delivery_document.lines = [];
            });
        }

        calculateHeight() {
            const tableHeight = $("md-table-container", this.$element).height() + 45;
            const documentLinesHeight = this.advanceForm ? $("mn-document-lines", this.$element).height() + 62 : 0;

            this.height = {
                'max-height': (tableHeight + documentLinesHeight + 45) + 'px',
                'min-height': '182px'
            };
        }

        catalogSelected() {
            if (!!this.selectedCatalog) {
                this.procedures = _.cloneDeep(this.selectedCatalog.procedures);
            } else {
                this.procedures = this.initProcedures;
            }
            localStorage.setItem(SELECTED_CATALOG_KEY, _.get(this.selectedCatalog, "id", null));
        }


    }

    module.exports = {
        bindings: {
            instance : "=",
        },
        template:require("./procedures-selection.tpl.html"),
        controllerAs: "vm",
        controller: ProceduresSelectionCtrl,
    };

})();
